
















































import { Component, Vue, Prop } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'
import BackofficeGlobalStore from '@/components/Backoffice/Store/BackofficeGlobalStore'
import EventBus from '@/plugins/EventBus'

@Component

export default class ComponentModalErroCoberturaVigente extends Vue {
  @Prop({ default: 'triagem', required: true }) parentModal: string

  get getBackofficeGlobalStore() {
    return getModule(BackofficeGlobalStore, this.$store)
  }

  get showModalErroCoberturaVigente() {
    return this.getBackofficeGlobalStore.modal.erroCoberturaVigente
  }

  set showModalErroCoberturaVigente(value: boolean) {
    this.getBackofficeGlobalStore.setModal({ name: 'erroCoberturaVigente', value })
  }

  cancelar() {
    EventBus.$emit('limparPendenciaAutomatica', true)
    this.showModalErroCoberturaVigente = false
  }

  sendCustomMessage() {
    this.showModalErroCoberturaVigente = false
    EventBus.$emit('abrirPendenciaAutomatica', this.parentModal)
  }
}
